import type express from 'express';

export type NextFunction = express.NextFunction;
